export default () => ({
  initialized: false,
  init() {
    if (this.initialized) return;
    this.initialized = true;
    const bundleOptions = document.querySelectorAll('.bundle-hero-offers .bundle-hero-offer');
    const bundleCTAs = document.querySelectorAll('.bundle-atcs .bundle-atc');

    function updateBundleElements(otherElements, updateElement, className) {
      //unselect all other buttons
      for (let j = 0; j < otherElements.length; j++) {
        otherElements[j].classList.remove(className);
      }
      //mark as selected
      updateElement.classList.add(className);
    }

    function updateBundleImage() {
      var selectedOption = document.querySelector('.bundle-hero-offers .bundle-hero-offer.selected');
      if (!selectedOption) return;

      let imageElement = document.querySelector('.bundle-main-image img');
      let mobileImageElement = document.querySelector('.bundle-sub-image.mobile-carousel-image img');
      let newImage = selectedOption.getAttribute('data-image');

      imageElement.setAttribute('srcset', newImage);
      imageElement.setAttribute('src', newImage);

      mobileImageElement.setAttribute('srcset', newImage);
      mobileImageElement.setAttribute('src', newImage);
    }

    function updateBundleCTAs(indx) {
      const updateElement = document.querySelector('.bundle-atcs .bundle-atc:nth-of-type(' + (indx + 1) + ')');
      for (let j = 0; j < bundleCTAs.length; j++) {
        bundleCTAs[j].classList.add('hidden');
      }
      //mark as selected
      updateElement.classList.remove('hidden');
    }

    for (let k = 0; k < bundleOptions.length; k++) {
      bundleOptions[k].addEventListener('click', function () {
        updateBundleElements(bundleOptions, this, 'selected');
        updateBundleImage();
        updateBundleCTAs(k);
      });
    }

    const bundleImages = document.querySelectorAll('.bundle-sub-image');
    const bundleMainImage = document.querySelector('.bundle-main-image img');
    for (let i = 0; i < bundleImages.length; i++) {
      bundleImages[i].addEventListener('click', function () {
        if (window.outerWidth > 767) return;
        const clickedImage = this.querySelector('img');
        bundleMainImage.setAttribute('srcset', clickedImage.getAttribute('srcset'));
      });
    }
  },
});
